import * as TK from 'components/auth/AuthPageWrapper/translations/constants';
import { Translations } from 'translations/types';

export const authPageEnUsLocale: Translations = {
  [TK.AUTH_PAGE_BANNER_TITLE]: 'Missio is what people on mission use to communicate.',
  [TK.AUTH_PAGE_BANNER_ALT]: 'banner',
};
